<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-3 small-12">
        <h6>Rapports Versement</h6>
        Gagné : {{ earnings }}
      </span>
      <div class="text-right medium-9 small-12">
        <div class="row">
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="status">Statut:</label>
            <select v-model="status" :disabled="!enabled" class="mbn mls mrs">
              <option
                v-for="(option, index) in statusOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mr"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="small-12 medium-6 flex-container align-middle">
            <label for="sortBy" style="white-space: nowrap"
              >Trier Par:</label
            >
            <select v-model="sortBy" :disabled="!enabled" class="mbn mls">
              <option
                v-for="(option, index) in sortOptions"
                :key="index"
                :value="option.value"
                :disabled="!enabled"
                class="mls mrs"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    earnings: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      sortBy: null,
      statusOptions: [
        {
          label: 'Tout',
          value: null,
        },
        {
          label: 'Intérim',
          value: 'Interim',
        },
        {
          label: 'En cours',
          value: 'Pending',
        },
        {
          label: 'Validé',
          value: 'Approved',
        },
        {
          label: 'Terminé',
          value: 'Completed',
        },
        {
          label: 'En attente',
          value: 'Held',
        },
        {
          label: 'Echec',
          value: 'Failed',
        },
      ],
      sortOptions: [
        {
          label: 'Date Sélectionnée',
          value: null,
        },
        {
          label: 'Date de paiement',
          value: 'Payment Date',
        },
        {
          label: 'Statut',
          value: 'Status',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async sortBy(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        sortBy: this.sortBy,
      });
    },
  },
};
</script>
